import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import ContentSubmissionView from '@/views/campaigns/content-submissions/ContentSubmissionView';
import {contentSubmissionOffPlatformReviewActions} from '@/stores/contentSubmissionOffPlatformReviewStore';

function OffPlatformContentSubmissionView() {
  const {campaignId} = useParams<{campaignId: string}>();

  useEffect(() => {
    if (campaignId) {
      contentSubmissionOffPlatformReviewActions.initReview(campaignId);
    }
    return () => contentSubmissionOffPlatformReviewActions.resetReview();
  }, [campaignId]);

  return <ContentSubmissionView isOffPlatform />;
}

export default OffPlatformContentSubmissionView;
